module.exports = require("core-js/library/fn/reflect/delete-property");